export const MAIN_CAROUSEL_TEST_IDS = {
  // ─── Hero Carousel ───
  container: 'main-carousel-container',
  slide: (index: number) => `main-carousel-slide-${index}`,
  slideImage: (index: number) => `main-carousel-slide-image-${index}`,
  slideLink: (index: number) => `main-carousel-slide-link-${index}`,
} as const;
